import React from 'react';
import { Clock } from 'lucide-react';

const EmptyState: React.FC = () => {
  return (
    <div className="w-full my-6 sm:my-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 sm:p-12">
        <div className="text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 mb-4">
            <Clock className="h-6 w-6 text-gray-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Trámite en curso
          </h3>
          <p className="text-gray-500 max-w-md mx-auto">
            En este momento no tienes trámites disponibles para revisar. Los trámites aparecerán aquí cuando estén listos para tu revisión.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;